var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'home': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/home.js